var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2560.000000pt",
    height: "2560.000000pt",
    viewBox: "0 0 2560.000000 2560.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,2560.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12870 l0 -12730 12765 0 12765 0 0 12730 0 12730 -12765 0 -12765 0 0 -12730z m23930 6378 c-1 -4559 -2 -4822 -18 -4803 -9 12 -359 411 -776 889 l-760 867 -1083 -1083 -1083 -1083 -3723 3723 -3722 3722 -3458 -3457 -3457 -3458 -797 798 -798 797 -1327 -1327 -1328 -1328 0 5283 0 5282 11165 0 11165 0 0 -4822z m-7742 -9235 l-2893 -2893 -3157 3157 -3158 3158 2892 2892 2893 2893 3157 -3157 3158 -3158 -2892 -2892z m-6153 -6153 l-2130 -2130 -3152 0 -3153 0 0 4786 c0 4348 1 4785 16 4773 13 -11 188 160 1327 1299 l1312 1312 3955 -3955 3955 -3955 -2130 -2130z m13084 9068 l811 -927 0 -5135 0 -5136 -6875 0 c-3781 0 -6875 3 -6875 7 0 11 12114 12123 12122 12121 3 -2 371 -420 817 -930z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10367 15822 l-2387 -2387 1330 -1330 c731 -731 1330 -1328 1330 -1325 0 3 477 1674 1060 3714 583 2040 1058 3711 1057 3712 -2 2 -1077 -1071 -2390 -2384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3172 11837 l-1062 -1062 1 -3190 1 -3190 1063 4250 c585 2337 1063 4251 1061 4252 -1 1 -480 -476 -1064 -1060z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20475 11040 l-1859 -1859 -263 -3143 c-144 -1729 -262 -3161 -262 -3183 0 -32 222 461 1060 2345 l1061 2385 1063 2658 c585 1461 1062 2657 1061 2657 0 0 -838 -837 -1861 -1860z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape);
export default __webpack_public_path__ + "static/media/Landscape.6bea1d6b1f55dabdcb5c0b0f4d0d1676.svg";
export { ForwardRef as ReactComponent };